/**
 * Generato automaticamente.
 * OpenAPI
 */
import { useMutation, useQuery } from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient.ts';
import type { ErrorType } from '../../../client/apiClient.ts';
import type { AnagraficaDTO } from '../schemas/anagraficaDTO.ts';
import type { AnagraficaRequest } from '../schemas/anagraficaRequest.ts';
import type { GetAnagraficheParams } from '../schemas/getAnagraficheParams.ts';
import type { WsProblema } from '../schemas/wsProblema.ts';
import type { WsRispostaPaginataListAnagraficaDTO } from '../schemas/wsRispostaPaginataListAnagraficaDTO.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Modifica Anagrafica.
 * @summary Modifica Anagrafica
 */
export const putAnagraficheId = (
  id: string,
  anagraficaRequest: AnagraficaRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<AnagraficaDTO>(
    {
      url: `/framework-cfg-domande/anagrafiche/${id}`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: anagraficaRequest,
    },
    options,
  );
};

export const getPutAnagraficheIdMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putAnagraficheId>>,
    TError,
    { id: string; data: AnagraficaRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putAnagraficheId>>,
  TError,
  { id: string; data: AnagraficaRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putAnagraficheId>>,
    { id: string; data: AnagraficaRequest }
  > = props => {
    const { id, data } = props ?? {};

    return putAnagraficheId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutAnagraficheIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putAnagraficheId>>
>;
export type PutAnagraficheIdMutationBody = AnagraficaRequest;
export type PutAnagraficheIdMutationError = ErrorType<WsProblema>;

/**
 * @summary Modifica Anagrafica
 */
export const usePutAnagraficheId = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putAnagraficheId>>,
    TError,
    { id: string; data: AnagraficaRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPutAnagraficheIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Elimina Anagrafica.
 * @summary Elimina Anagrafica
 */
export const deleteAnagraficheId = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<void>(
    { url: `/framework-cfg-domande/anagrafiche/${id}`, method: 'delete' },
    options,
  );
};

export const getDeleteAnagraficheIdMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAnagraficheId>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAnagraficheId>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAnagraficheId>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteAnagraficheId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAnagraficheIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAnagraficheId>>
>;

export type DeleteAnagraficheIdMutationError = ErrorType<WsProblema>;

/**
 * @summary Elimina Anagrafica
 */
export const useDeleteAnagraficheId = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAnagraficheId>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getDeleteAnagraficheIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Ritorna l'elenco delle variabili anagrafiche relative alla ricerca.
 * @summary Elenco Anagrafiche
 */
export const getAnagrafiche = (
  params?: GetAnagraficheParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<WsRispostaPaginataListAnagraficaDTO>(
    {
      url: `/framework-cfg-domande/anagrafiche`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetAnagraficheQueryKey = (params?: GetAnagraficheParams) =>
  [`/framework-cfg-domande/anagrafiche`, ...(params ? [params] : [])] as const;

export const getGetAnagraficheQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnagrafiche>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAnagraficheParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAnagrafiche>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getAnagrafiche>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAnagraficheQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnagrafiche>>> = ({
    signal,
  }) => getAnagrafiche(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetAnagraficheQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnagrafiche>>
>;
export type GetAnagraficheQueryError = ErrorType<unknown>;

/**
 * @summary Elenco Anagrafiche
 */
export const useGetAnagrafiche = <
  TData = Awaited<ReturnType<typeof getAnagrafiche>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAnagraficheParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAnagrafiche>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAnagraficheQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Crea una nuova Anagrafica.
 * @summary Crea Anagrafica
 */
export const postAnagrafiche = (
  anagraficaRequest: AnagraficaRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<AnagraficaDTO>(
    {
      url: `/framework-cfg-domande/anagrafiche`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: anagraficaRequest,
    },
    options,
  );
};

export const getPostAnagraficheMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAnagrafiche>>,
    TError,
    { data: AnagraficaRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAnagrafiche>>,
  TError,
  { data: AnagraficaRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAnagrafiche>>,
    { data: AnagraficaRequest }
  > = props => {
    const { data } = props ?? {};

    return postAnagrafiche(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAnagraficheMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAnagrafiche>>
>;
export type PostAnagraficheMutationBody = AnagraficaRequest;
export type PostAnagraficheMutationError = ErrorType<WsProblema>;

/**
 * @summary Crea Anagrafica
 */
export const usePostAnagrafiche = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAnagrafiche>>,
    TError,
    { data: AnagraficaRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostAnagraficheMutationOptions(options);

  return useMutation(mutationOptions);
};
